// extracted by mini-css-extract-plugin
export var currencyInput = "_oy-1";
export var currencySymbol = "_oy-0";